import { ChevronDown } from "lucide-react"

import {
  Button,
  ButtonProps,
  NonTonalButtonMode,
} from "../../../../components/base/control/Button"
import { IconProps } from "../../../../components/Icon"
import { classNames } from "../../../../lib/classNames"

interface DropdownButtonProps
  extends Omit<ButtonProps, "mode" | "tone">,
    Pick<IconProps, "icon"> {
  mode: NonTonalButtonMode
  label: string
  hideDropdownIcon?: boolean
}

export function DropdownButton(props: DropdownButtonProps) {
  const { icon, label, hideDropdownIcon, className, ...buttonProps } = props

  return (
    <Button
      leftIcon={icon}
      rightIcon={hideDropdownIcon ? undefined : ChevronDown}
      size="small"
      className={classNames(
        "max-w-80 justify-start overflow-hidden",
        className
      )}
      {...buttonProps}
    >
      <span className="truncate">{label}</span>
    </Button>
  )
}
